import React, { Component } from 'react'
import moment from 'moment';
// import FixedView from '../FixedView';
// import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
import CalendarViewer from '../views/CalendarViewer';
// import settings from '../../stores/middlewares/settings.middleware';
import SidebarView from '../SidebarView';
import CheckBoxListInput from './CheckBoxListInput';
import ButtonAnimated from '../buttons/ButtonAnimated';
import { nanoid } from 'nanoid';
import PriceInput from './PriceInput';


class OrganizerCalendarInput extends Component {


    state = {

        view: {
            settings: {
                stacked: {
                    date: 'date',
                    viewKey: 'price'
                },
                availableViews: ['month'],
                cardInfo: [{ "id": "qapgLqzThL8XOzT-5tXQn", "children": [{ "id": "2oJ10F-K6o8oUiPGKiCnS", "children": [{ "id": "AMvdkfcBEnAl7CbAayAqL", "key": "AMvdkfcBEnAl7CbAayAqL", "type": "TextWidget", "information": { "content": "<span style=\"font-size: 13px;\">{{Current Record - Price}}<span>​​</span><span>​​</span></span>", }, "parents": [{ "id": "qapgLqzThL8XOzT-5tXQn", "type": "row" }, { "id": "2oJ10F-K6o8oUiPGKiCnS", "type": "column", "style": { "width": { "xs": 100, "md": 100, "lg": 100 } } }] }], "type": "column", "temp": false, "style": { "width": { "xs": 100, "md": 100, "lg": 100 } }, "parents": [{ "id": "qapgLqzThL8XOzT-5tXQn", "type": "row" }] }], "type": "row", "temp": false, "parents": [] }, { "id": "86nTR2lEI4K0LpSlnS7ms", "children": [{ "id": "HpEESw-Smt_DhEgXUsV_J", "children": [{ "id": "up-dSXl2tpXD2MSPkc3zQ", "key": "up-dSXl2tpXD2MSPkc3zQ", "type": "TextWidget", "information": { "content": "<span style=\"font-size: 11px;color: #ee5050;\">​{{Current Record - Availability}}</span>", "applet": "undefined" }, "parents": [{ "id": "86nTR2lEI4K0LpSlnS7ms", "type": "row" }, { "id": "HpEESw-Smt_DhEgXUsV_J", "type": "column", "style": { "width": { "xs": 100, "md": 100, "lg": 100 } } }] }], "type": "column", "temp": false, "style": { "width": { "xs": 100, "md": 100, "lg": 100 } }, "parents": [{ "id": "86nTR2lEI4K0LpSlnS7ms", "type": "row" }] }], "type": "row", "temp": false, "parents": [] }],
            }
        },

        defaultData: {
            price: 100
        },

        data: [
            // { id: '1', date: { from: '2025-03-12', to: '2025-03-17', recurring: { frequency: 'd', interval: 1 } }, price: 200 },
            // { id: '2', date: { from: '2025-03-20', to: '2025-03-25', recurring: { frequency: 'd', interval: 1 } }, price: 200, availability: "blocked", },
        ],


        headers: [
            { key: 'price', type: 'TextInput', col: '4', information: { label: '{{lang}}Price', isSearchable: true, placeholder: '{{lang}}Price', required: true }, showMain: true },
            { key: 'availability', type: 'TextInput', col: '4', information: { label: '{{lang}}Availability', isSearchable: true, placeholder: '{{lang}}Price', required: true }, showMain: true },

        ]


    }


    changeValue = (value) => {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    openSelectStack = () => {
        // console.log("openSelectStack")
    }

    onDatesSelect = (start, end, status) => {

        let selectedDates = this.state.selectedDates ?? {}

        if (status == 'start') {
            selectedDates.start = start
            selectedDates.end = end
            this.initialSelectedDates = { ...selectedDates }
        } else {

            if (start >= this.initialSelectedDates.end) {
                selectedDates.end = end
                selectedDates.start = this.initialSelectedDates.start

            } else if (end <= this.initialSelectedDates.start) {
                selectedDates.start = start
                selectedDates.end = this.initialSelectedDates.end

            }

            if (start == this.initialSelectedDates.start && end == this.initialSelectedDates.end) {
                selectedDates = { ... this.initialSelectedDates }
            }

            // console.log(start >= this.initialSelectedDates.end, end <= this.initialSelectedDates.start)
        }

        let currentData = {}
        let mixedData = {}
        let defaultData = this.state.defaultData
        if (status == 'end') {
            // console.log(selectedDates.end, selectedDates.start)
            // console.log(moment(this.props.data[1].date.from).valueOf(), selectedDates.start)
            // console.log(moment(this.props.data[1].date.from).valueOf(), selectedDates.start)

            // console.log(moment(this.props.data[1].date.from).valueOf() <= selectedDates.start)
            // console.log(moment(this.props.data[1].date.to).valueOf() >= selectedDates.end)

            //    let { currentData, mixedData } = this.createCurrentData(selectedDates)
            let result = this.createCurrentData(selectedDates)

            // console.log(result)
            currentData = result.currentData
            mixedData = result.mixedData

            let tempData = {
                price: !mixedData.price ? currentData.price : defaultData.price,
                availability: !mixedData.availability ? currentData.availability : defaultData.availability,
                note: !mixedData.note ? currentData.note : defaultData.note,
                rules: !mixedData.rules ? currentData.rules : defaultData.rules,
            }

            this.setState({ tempData })

            // console.log(currentData, mixedData)

            this.configSidebar.open()

            // console.log(currentData,mixedData)

            // console.log(rangeData)
            // console.log(this.checkForEmptyDates(selectedDates.start, selectedDates.end, rangeData))
            // let rangeData = calendarData.filter(item => moment(item.date.from).valueOf() >= selectedDates.start && moment(item.date.from).valueOf() <= selectedDates.end)
            // console.log(currentData)

        }

        let formatedSelectedDates = { start: {}, end: {} }
        let finalSelectedDatesText = ''

        if (this.state.selectedDates?.start) {
            formatedSelectedDates.start.day = moment(this.state.selectedDates?.start).format("DD")
            formatedSelectedDates.start.month = moment(this.state.selectedDates?.start).format("MMMM")
            formatedSelectedDates.start.year = moment(this.state.selectedDates?.start).format("YYYY")
        }

        if (this.state.selectedDates?.end) {
            formatedSelectedDates.end.day = moment(this.state.selectedDates?.end).format("DD")
            formatedSelectedDates.end.month = moment(this.state.selectedDates?.end).format("MMMM")
            formatedSelectedDates.end.year = moment(this.state.selectedDates?.end).format("YYYY")
        }

        if (this.state.selectedDates?.start && this.state.selectedDates?.end) {
            finalSelectedDatesText = ''

            if (formatedSelectedDates.start.day != formatedSelectedDates.end.day || formatedSelectedDates.start.month != formatedSelectedDates.end.month || formatedSelectedDates.start.year != formatedSelectedDates.end.year) {
                finalSelectedDatesText = `${formatedSelectedDates.start.day}`
            }

            if (formatedSelectedDates.start.month != formatedSelectedDates.end.month || formatedSelectedDates.start.year != formatedSelectedDates.end.year) {
                finalSelectedDatesText = finalSelectedDatesText + ` ${formatedSelectedDates.start.month}`
            }

            if (formatedSelectedDates.start.year != formatedSelectedDates.end.year) {
                finalSelectedDatesText = finalSelectedDatesText + ` ${formatedSelectedDates.start.year}`
            }

            if (finalSelectedDatesText != '') {
                finalSelectedDatesText = finalSelectedDatesText + ' - '
            }

            finalSelectedDatesText = finalSelectedDatesText + `${moment(this.state.selectedDates?.end).format("DD MMMM YYYY")}`

        }


        // console.log("selectedDates", this.initialSelectedDates, selectedDates, start, end)
        this.setState({ currentData, mixedData, selectedDates, formatedSelectedDates, finalSelectedDatesText })

    }



    createCurrentData = (selectedDates) => {

        // console.log(this.props.data)
        let rangeData = this.findOverlappingDates(selectedDates.start, selectedDates.end, (this.props.data ?? [])) //this.props.data.filter(item => (moment(item.date.from).valueOf() <= selectedDates.start && moment(item.date.from).valueOf() <= selectedDates.end)) ?? []
        // && moment(item.date.end).valueOf() >= selectedDates.end

        // console.log(selectedDates)
        // console.log(this.props.data)
        // console.log(rangeData)
        let needsDefault = this.checkForEmptyDates(selectedDates.start, selectedDates.end, rangeData)

        let defaultData = this.state.defaultData

        if (needsDefault) {
            rangeData.push(defaultData)
        }

        let price = [...new Set(rangeData.map(item => item.price))];
        let availability = [...new Set(rangeData.map(item => item.availability))];
        let note = [...new Set(rangeData.map(item => item.note))];
        let rules = [...new Set(rangeData.map(item => item.rules))];


        let currentData = {
            price: price.length == 1 ? price[0] : defaultData.price,
            availability: availability.length == 1 ? availability[0] : defaultData.availability,
            note: note.length == 1 ? note[0] : defaultData.note,
            rules: rules.length == 1 ? rules[0] : defaultData.rules,
        }

        let mixedData = {
            price: price.length > 1,
            availability: availability.length > 1,
            note: note.length > 1,
            rules: rules.length > 1,
        }

        // console.log(currentData, mixedData)
        return { currentData, mixedData }

    }



    checkForEmptyDates = (startDate, endDate, ranges) => {
        let currentDate = moment(startDate);
        const finalDate = moment(endDate);
        let needsDefault = false
        // console.log(ranges)
        while (currentDate.isSameOrBefore(finalDate)) {
            let foundInRange = ranges.filter(({ date }) => {
                const from = date.from
                const to = date.to
                // console.log(currentDate,from, to)
                // console.log(currentDate.isBetween(moment(from), moment(to), "day", "[]"))
                return currentDate.isBetween(moment(from).startOf('day'), moment(to).endOf('day'), "day", "[]")
            })
            // console.log(foundInRange, currentDate)

            if (foundInRange.length == 0) {
                return true; // Found an empty date
            }

            currentDate.add(1, "day"); // Move to the next day
        }

        if (ranges.length == 0) {
            return true
        }


        return needsDefault; // gaps found
    }



    findDateGaps(startDate, endDate, ranges) {

        let currentDate = moment(startDate);
        let lastValidStartDate
        let lastValidEndDate

        const finalDate = moment(endDate);
        // let needsDefault = false
        let gaps = []
        // console.log(ranges)
        while (currentDate.isSameOrBefore(finalDate)) {
            let foundInRange = ranges.filter(({ date }) => {
                const from = date.from
                const to = date.to
                return currentDate.isBetween(moment(from).startOf('day'), moment(to).endOf('day'), "day", "[]")
            })
            // console.log(foundInRange, currentDate)

            if (foundInRange.length > 0) {

                if (lastValidStartDate) {
                    gaps.push({ from: lastValidStartDate, to: lastValidEndDate })
                    lastValidStartDate = null
                    lastValidEndDate = null
                }

            } else {

                if (!lastValidStartDate) {
                    lastValidStartDate = currentDate.startOf('day').valueOf()
                }

                lastValidEndDate = currentDate.endOf('day').valueOf()
            }

            currentDate.add(1, "day"); // Move to the next day
        }

        if (lastValidStartDate) {
            gaps.push({ from: lastValidStartDate, to: lastValidEndDate })
        }


        // if (ranges.length == 0) {
        //     return true
        // }


        return gaps
    }


    findOverlappingDates = (checkFrom, checkTo, ranges) => {
        const start = moment(checkFrom);
        const end = moment(checkTo);

        return ranges.filter(({ date }) => {
            const from = moment(date.from).startOf('day');
            const to = moment(date.to).endOf('day');
            const rangeStart = moment(from);
            const rangeEnd = moment(to);

            return rangeStart.isBefore(end) && rangeEnd.isAfter(start);
        });
    };

    functionsHandler = (type, name, data, extra, cb) => {

        if (this[name]) {
            this[name](data, extra, cb)
        }

    }


    openEditModal = (data, extra, cb) => {

    }


    changeTempValue = (key, value) => {

        // console.log(key, value)
        let tempData = this.state.tempData ?? {}
        tempData[key] = value
        // console.log(tempData)
        this.setState({ tempData })
        // console.log(key, value)

    }

    submitNewValue = (key) => {


        let tempData = this.state.tempData

        // console.log(tempData[key], this.state.currentData[key])
        // console.log(this.state.mixedData[key])

        let value = tempData[key]
        // if (value == null) {
        //     value = this.state.currentData[key]
        // }

        // console.log(value,this.state.currentData[key])

        if (this.state.mixedData[key] || value != this.state.currentData[key]) {

            let data = this.props.data ? [...this.props.data] : []
            let selectedDates = this.state.selectedDates

            let rangeData = this.findOverlappingDates(selectedDates.start, selectedDates.end, data)
            // let newDateRangeAdded = false
            // console.log(rangeData)

            if (rangeData.length == 0) {

                let newRange = { ...this.state.defaultData }
                newRange.id = nanoid()
                newRange.date = { from: selectedDates.start, to: selectedDates.end, recurring: { frequency: 'd', interval: 1 } }
                newRange[key] = value

                // console.log(newRange)
                data.push(newRange)

            } else {

                for (let i = 0; i < rangeData.length; i++) {
                    let oneRangeData = rangeData[i]

                    if (moment(oneRangeData.date.from).valueOf() >= selectedDates.start && moment(oneRangeData.date.to).valueOf() <= selectedDates.end) {
                        // oneRangeData[key] = value

                        for (let j = 0; j < data.length; j++) {
                            const element = data[j]

                            if (element.id == oneRangeData.id) {
                                data[j][key] = value
                            }
                        }

                    } else {

                        // console.log(oneRangeData.date)
                        let newData = []
                        let newDateRangeAdded = false
                        if (moment(oneRangeData.date.from).valueOf() < selectedDates.start) {
                            let myOlderRange = JSON.parse(JSON.stringify(oneRangeData))
                            myOlderRange.date.to = moment(selectedDates.start).subtract(1, 'days').endOf('day').valueOf()
                            myOlderRange.id = nanoid()
                            newData.push(myOlderRange)

                            myOlderRange = JSON.parse(JSON.stringify(oneRangeData))
                            myOlderRange.id = nanoid()
                            myOlderRange.date.from = selectedDates.start
                            myOlderRange.date.to = oneRangeData.date.to
                            myOlderRange[key] = value
                            newData.push(myOlderRange)
                            newDateRangeAdded = true

                        }

                        // console.log(moment(oneRangeData.date.to).valueOf(), selectedDates.end)

                        if (moment(oneRangeData.date.to).valueOf() > selectedDates.end) {
                            let myAfterRange = JSON.parse(JSON.stringify(oneRangeData))
                            myAfterRange.id = nanoid()
                            myAfterRange.date.from = moment(selectedDates.end).add(1, 'days').startOf('day').valueOf()
                            newData.push(myAfterRange)

                            if (!newDateRangeAdded) {

                                myAfterRange = JSON.parse(JSON.stringify(oneRangeData))
                                myAfterRange.id = nanoid()
                                myAfterRange.date.from = oneRangeData.date.from
                                myAfterRange.date.to = selectedDates.end
                                myAfterRange[key] = value
                                newData.push(myAfterRange)
                                newDateRangeAdded = true
                            }
                        }

                        // if (!newDateRangeAdded) {
                        //     let newRange = JSON.parse(JSON.stringify(oneRangeData))
                        //     newRange.id = nanoid()
                        //     newRange.date = { from: selectedDates.start, to: selectedDates.end, recurring: { frequency: 'd', interval: 1 } }
                        //     newRange[key] = value
                        //     newData.push(newRange)
                        //     newDateRangeAdded = true
                        // }

                        // console.log(newData)

                        for (let j = 0; j < data.length; j++) {
                            const element = data[j]

                            if (element.id == oneRangeData.id) {
                                data.splice(j, 1)
                            }
                        }

                        data = [...data, ...newData]



                    }
                }

                // console.log("dateGaps", JSON.parse(JSON.stringify(data)))

                let dateGaps = this.findDateGaps(selectedDates.start, selectedDates.end, data)
                // console.log("dateGaps", dateGaps)
                for (let g = 0; g < dateGaps.length; g++) {
                    const gap = dateGaps[g];
                    let newObject = this.state.defaultData ? JSON.parse(JSON.stringify(this.state.defaultData)) : {}
                    newObject.id = nanoid()
                    newObject.date = { from: gap.from, to: gap.to, recurring: { frequency: 'd', interval: 1 } }
                    newObject[key] = value
                    // console.log(newObject)
                    data.push(newObject)
                }

            }


            // console.log(data)
            this.changeValue(data)

            // this.setState({ data }, () => {
            setTimeout(() => {

                let { currentData, mixedData } = this.createCurrentData(selectedDates)
                // console.log(currentData,mixedData)
                this.setState({ currentData, mixedData })


            }, 100);



            // })


        }

        this.availabilitySidebar.close()
        this.priceSidebar.close()

    }



    render() {
        let info = this.props.header.information

        return (
            <div className='mt-0 w-100 h-100 br-2' >
                <CalendarViewer
                    data={this.props.data}
                    defaultData={this.state.defaultData}
                    applet={this.props.applet}
                    changeValue={this.props.changeValue}
                    stackedKey={this.props.stackedKey}
                    actions={this.props.actions}
                    width={this.props.width}
                    headers={this.state.headers}
                    submitForm={this.props.submitForm}
                    functionsHandler={this.functionsHandler}
                    view={this.state.view}
                    openSelectStack={this.openSelectStack}
                    onDatesSelect={this.onDatesSelect}
                    page={this.props.page}
                    isOrganizer={true}
                    selectedDates={this.state.selectedDates}

                    permissions={this.props.permissions}
                    saveUserSettings={this.props.saveUserSettings}
                    userSettings={this.props.userSettings}

                    isLoading={this.props.isLoadingData}
                    setCurrentHead={this.props.setCurrentHead}
                    setData={this.props.setData}
                    currentHead={this.props.currentHead}
                    initData={this.props.initData}
                    variables={this.props.variables}
                    hideHeaderField={this.props.hideHeaderField}
                    deleteHeaderField={this.props.deleteHeaderField}
                    limit={this.props.limit}
                    currentPage={this.props.currentPage}
                    totalCount={this.props.totalCount}
                    changePage={this.props.changePage}
                    currentRecord={this.props.currentRecord}
                    currentRecordStage={this.props.currentRecordStage}
                    changeRecordStage={this.props.changeRecordStage}
                    setCurrentRecordStage={this.props.setCurrentRecordStage}
                    colors={this.props.colors}
                    params={this.props.params}
                    defaultStackedKey={this.props.defaultStackedKey}
                    currentFrame={this.props.currentFrame}
                    changeStackedKey={this.props.setStackedKey}

                />


                <SidebarView width={this.props.width} ref={el => this.configSidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "40%", xl: "30%" }} onClose={this.onClose} left={50} >
                    <div className='w-100 h-100 scroll-no-scrollbar'>

                        <div className='px-3 py-2 flexcb' style={{ backgroundColor: '#fff', borderBottom: '0px solid #e0e0e0' }}>
                            <div>
                                <p className='text-bold font-size-16'>{translate("Dates customization")}</p>
                                <p className='text-semibold font-size-14 '>{this.state.finalSelectedDatesText}</p>
                            </div>

                            <button className='' onClick={() => { this.configSidebar.close() }}>
                                <img src="/images/close.svg" style={{ width: 14, height: 14, }} alt='' />
                            </button>
                        </div>

                        <div className='px-3 '>

                            <div className='mt-2 pb-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
                                <div className='flexcb'>
                                    <p className='text-semibold font-size-15'>{translate("Availability")}</p>
                                    <button className='text-link font-size-14' onClick={() => { this.availabilitySidebar.open() }}>{translate("Edit")}</button>
                                </div>
                                {this.state.mixedData?.availability ? (
                                    <div className='mt-1 flexc'>
                                        <p className='font-size-13 py-1' >{translate("Mixed data")}</p>
                                    </div>
                                ) : (
                                    <div className='mt-2 flexc'>
                                        <p className='font-size-13 br-20 px-3 py-1 text-semibold' style={{ border: `1.3px solid ${this.state.currentData?.availability ? "rgb(238, 80, 80)" : "rgb(0, 205, 116)"}`, color: this.state.currentData?.availability ? "rgb(238, 80, 80)" : "rgb(0, 205, 116)" }}>{this.state.currentData?.availability ? translate("Blocked") : translate("Open")}</p>
                                    </div>

                                )}
                            </div>


                            <div className='mt-2 pb-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
                                <div className='flexcb'>
                                    <p className='text-semibold font-size-15'>{translate("Base price")}</p>
                                    <button className='text-link font-size-14' onClick={() => { this.priceSidebar.open() }}>{translate("Edit")}</button>
                                </div>

                                <div className='mt-1 flexc'>
                                    <p className='font-size-13 py-1' >{this.state.mixedData?.price ? translate("Mixed data") : this.state.currentData?.price}</p>
                                </div>
                            </div>



                            <div className='mt-2 pb-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
                                <div className='flexcb'>
                                    <p className='text-semibold font-size-15'>{translate("Pricing and availibility rules")}</p>
                                    <button className='text-link font-size-14' onClick={() => { this.configSidebar.close() }}>{translate("Add")}</button>
                                </div>

                                <div className='mt-1 flexc'>
                                    <p className='font-size-12 py-1 ' style={{ color: '#777' }}>{translate("Add custom pricing offers or availibility rules. You can create offers in the offers section and add them here")}</p>
                                </div>
                            </div>




                            <div className='mt-2 pb-3' style={{ borderBottom: '0px solid #e0e0e0' }}>
                                <div className='flexcb'>
                                    <p className='text-semibold font-size-15'>{translate("Private note")}</p>
                                    <button className='text-link font-size-14' onClick={() => { this.configSidebar.close() }}>{translate("Edit")}</button>
                                </div>

                                <div className='mt-1 flexc'>
                                    <p className='font-size-12 py-1 ' style={{ color: '#777' }} >{this.state.mixedData?.note ? translate("Mixed data") : this.state.currentData?.note}</p>
                                </div>
                            </div>


                        </div>
                    </div>

                </SidebarView>




                <SidebarView width={this.props.width} ref={el => this.availabilitySidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "40%", xl: "30%" }} onClose={this.onClose} left={50} >
                    <div className='w-100 h-100 scroll-no-scrollbar'>

                        <div className='px-3 py-2 flexcb' style={{ backgroundColor: '#fff', borderBottom: '0px solid #e0e0e0' }}>
                            <div>
                                <p className='text-bold font-size-16'>{translate("Change availability")}</p>
                                <p className='text-semibold font-size-14 '>{this.state.finalSelectedDatesText}</p>
                            </div>

                            <div className='flexc'>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { !this.state.isLoading && this.submitNewValue('availability') }}
                                    title={translate('Submit')}
                                    icon='/assets/icons/arrow-right-white.svg'
                                    textColor={this.props.colors?.iconInvert ? '#000' : '#fff'}
                                    invert={this.props.colors?.iconInvert}
                                    bg={this.props.colors?.iconInvert ? '#fff' : '#4f4790'}
                                    isLoading={this.state.isLoading}
                                />

                                <button className='mld-3 flexcc' onClick={() => { this.availabilitySidebar.close() }}>
                                    <img src="/images/close.svg" style={{ width: 14, height: 14, }} alt='' />
                                </button>

                            </div>
                        </div>

                        <div className='px-3 '>

                            <div className='mt-2 pb-3' style={{ borderBottom: '0px solid #e0e0e0' }}>
                                <CheckBoxListInput width={this.props.width} colors={this.props.colors} data={this.state.currentData?.availability} header={{ key: 'availability', information: { type: 'local', items: [{ value: null, title: 'Open', description: 'This option leaves the dates open and available for booking.' }, { value: 'blocked', title: 'Block', description: 'This option blocks the dates to prevent booking/rental.' }], required: true } }} changeValue={this.changeTempValue} />

                            </div>

                        </div>
                    </div>

                </SidebarView>





                <SidebarView width={this.props.width} ref={el => this.priceSidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "40%", xl: "30%" }} onClose={this.onClose} left={50} >
                    <div className='w-100 h-100 scroll-no-scrollbar'>

                        <div className='px-3 py-2 flexcb' style={{ backgroundColor: '#fff', borderBottom: '0px solid #e0e0e0' }}>
                            <div>
                                <p className='text-bold font-size-16'>{translate("Change price")}</p>
                                <p className='text-semibold font-size-14 '>{this.state.finalSelectedDatesText}</p>
                            </div>

                            <div className='flexc'>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { !this.state.isLoading && this.submitNewValue('price') }}
                                    title={translate('Submit')}
                                    icon='/assets/icons/arrow-right-white.svg'
                                    textColor={this.props.colors?.iconInvert ? '#000' : '#fff'}
                                    invert={this.props.colors?.iconInvert}
                                    bg={this.props.colors?.iconInvert ? '#fff' : '#4f4790'}
                                    isLoading={this.state.isLoading}
                                />

                                <button className='mld-3 flexcc' onClick={() => { this.priceSidebar.close() }}>
                                    <img src="/images/close.svg" style={{ width: 14, height: 14, }} alt='' />
                                </button>

                            </div>
                        </div>

                        <div className='px-3 '>
                            <div className='mt-2 pb-3' style={{ borderBottom: '0px solid #e0e0e0' }}>
                                <div className='flexc bordered-input'>
                                    <PriceInput width={this.props.width} colors={this.props.colors} data={this.state.tempData?.price !== undefined ? this.state.tempData?.price : this.state.currentData?.price} header={{ key: 'price', information: { withDiscount: false, required: true } }} changeValue={this.changeTempValue} />
                                </div>
                            </div>

                        </div>
                    </div>

                </SidebarView>

            </div>
        )
    }
}

export default OrganizerCalendarInput;